// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Summary_wrapper__2ogMO","content":"Summary_content__3MyJx","header":"Summary_header__2i8pu","price_summary":"Summary_price_summary__JbnjT"};